// Utilitário para cálculo de feriados nacionais e bancários usando regras matemáticas
// Baseado no algoritmo de Meeus/Jones/Butcher para cálculo da Páscoa.

/**
 * Retorna a data da Páscoa para um determinado ano.
 */
function calcularPascoa(ano) {
    const a = ano % 19;
    const b = Math.floor(ano / 100);
    const c = ano % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const L = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * L) / 451);
    const mes = Math.floor((h + L - 7 * m + 114) / 31);
    const dia = ((h + L - 7 * m + 114) % 31) + 1;
    return new Date(ano, mes - 1, dia);
}

/**
 * Gera um Set de strings "YYYY-MM-DD" com todos os feriados bancários de um ano
 */
function gerarFeriadosBancarios(ano) {
    const feriados = new Set();
    
    // Feriados Fixos Nacionais
    feriados.add(`${ano}-01-01`); // Confraternização Universal
    feriados.add(`${ano}-04-21`); // Tiradentes
    feriados.add(`${ano}-05-01`); // Dia do Trabalho
    feriados.add(`${ano}-09-07`); // Independência do Brasil
    feriados.add(`${ano}-10-12`); // Nossa Senhora Aparecida
    feriados.add(`${ano}-11-02`); // Finados
    feriados.add(`${ano}-11-15`); // Proclamação da República
    feriados.add(`${ano}-12-25`); // Natal

    // Feriado Bancário Fixo (Febraban: 31/12 não tem expediente)
    feriados.add(`${ano}-12-31`); 

    // Feriados Móveis
    const pascoa = calcularPascoa(ano);
    
    const addDias = (dataBase, dias) => {
        const d = new Date(dataBase);
        d.setDate(d.getDate() + dias);
        const isoStr = d.toISOString().split('T')[0];
        feriados.add(isoStr);
    };

    addDias(pascoa, -2);  // Sexta-feira Santa
    addDias(pascoa, -47); // Terça de Carnaval
    addDias(pascoa, -48); // Segunda de Carnaval (Febraban: sem expediente)
    addDias(pascoa, 60);  // Corpus Christi

    return feriados;
}

// Cache por ano para performance
const cacheFeriados = {};

/**
 * Verifica se uma data é dia útil bancário (não é FDS e não é feriado nacional)
 */
export const isDiaUtilBancario = (data) => {
    const ano = data.getFullYear();
    if (!cacheFeriados[ano]) {
        cacheFeriados[ano] = gerarFeriadosBancarios(ano);
    }
    
    const diaSemana = data.getDay();
    if (diaSemana === 0 || diaSemana === 6) {
        return false; // FDS
    }

    const isoStr = data.toISOString().split('T')[0];
    if (cacheFeriados[ano].has(isoStr)) {
        return false; // Feriado Bancário
    }

    return true;
};

/**
 * Adiciona D dias úteis a uma data, respeitando regras bancárias
 */
export const adicionarDiasUteis = (dataIsoString, dias) => {
    // Tratar fuso horário e criar data segura ao meio-dia
    const partes = dataIsoString.split('-');
    const data = new Date(partes[0], partes[1] - 1, partes[2], 12, 0, 0);
    
    let diasAdicionados = 0;
    while (diasAdicionados < dias) {
        data.setDate(data.getDate() + 1);
        if (isDiaUtilBancario(data)) {
            diasAdicionados++;
        }
    }
    
    return data.toISOString().split('T')[0];
};
